<template>
  <div class="mx-auto col-sm-12">
    <form id="activeForm" @submit.prevent>
      <div class="row mb-3">
        <div class="form-group col-lg-4">
          <label for="model">{{ $t("model") }}</label>
          <Combobox
            class="bg-white"
            name="model"
            :hasErrors="errors.has('model')"
            :placeholder="$t('select_a_item')"
            label="name"
            :options="models"
            :getOptionLabel="
              (model) =>
                model.name ? model.manufacturer.name + ' / ' + model.name : ''
            "
            :initial-value="active.model"
            v-model="active.model"
            :reduce="(models) => models.id"
            v-validate="'required'"
          />

          <small v-show="errors.has('model')" class="form-text">
            {{ errors.first("model") }}
          </small>
        </div>

        <div
          class="form-group col-lg-3"
          :class="{ 'has-error': errors.has('purchase_date') }"
        >
          <label for="purchase_date">{{ $t("purchase_date") }}</label>
          <input
            type="date"
            id="purchase_date"
            name="purchase_date"
            class="form-control"
            v-model="active.purchaseDate"
          />

          <small
            v-show="errors.has('purchase_date')"
            class="form-text text-muted"
          >
            {{ errors.first("purchase_date") }}
          </small>
        </div>

        <div
          class="form-group col-lg-2"
          :class="{ 'has-error': errors.has('purchase_value') }"
        >
          <label for="purchase_value"
            >{{ $t("purchase_value") }} (unitário)</label
          >
          <CurrencyInput
            v-model="active.purchaseValue"
            :auto-decimal-mode="true"
            :distraction-free="false"
            currency="BRL"
            locale="pt-BR"
            class="demo__currency-input form-control"
          />

          <small
            v-show="errors.has('purchase_value')"
            class="form-text text-muted"
          >
            {{ errors.first("purchase_value") }}
          </small>
        </div>

        <div
          class="form-group col-lg-3"
          :class="{ 'has-error': errors.has('warranty_date') }"
        >
          <label for="warranty_date">{{ $t("warranty_date") }}</label>
          <input
            type="date"
            id="warranty_date"
            name="warranty_date"
            class="form-control"
            v-model="active.warrantyDate"
          />
          <small
            v-show="errors.has('warranty_date')"
            class="form-text text-muted"
          >
            {{ errors.first("warranty_date") }}
          </small>
        </div>

        <div class="form-group col-lg-12 mt-3">
          <b-form-file
            v-model="file"
            :state="Boolean(file)"
            placeholder="Selecione a planilha ..."
            drop-placeholder="Drop file here..."
            accept='.xlsx'
            browse-text='Buscar'
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-4 col-sm-offset-2">
          <LoaderButton @click="onClick" :disabled="!file">
            {{ $t("save") }}
          </LoaderButton>
        </div>
      </div>
    </form>

    <!-- MODAL ERRORS -->
    <div class="modal fade" id="modalErrors" tabindex="-1" role="dialog" aria-labelledby="modalErrorsLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalErrorsLabel">Erros</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul v-for="error in addSimcardsBatchErrors" :key="error.code">
              <li>
                <strong>{{ error.serie }}</strong>: {{ error.error }}
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary block m-b mt-3 mr-2"
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";
import BootstrapTable from "bootstrap-table/dist/bootstrap-table-vue.esm.js";
import Combobox from "@/components/shared/ComboBox";

export default {
  name: "AddSimcardsBatch",
  components: {
    LoaderButton,
    BootstrapTable,
    Combobox,
  },

  data() {
    return {
      active: {
        model: undefined,
        purchaseDate: "",
        purchaseValue: 0,
        warrantyDate: "",
        activeType: 6,
        location: '',
        status: undefined
      },
      file: null
    };
  },

  computed: {
    ...mapState({
      models: (state) => state.model.all,
      activestypes: state => state.activestype.all,
      addSimcardsBatchErrors: state => state.active.addSimcardsBatchErrors,
    }),
  },

  methods: {
    ...mapActions("active", ["create", "edit", "cleanState", "addSimcardsBatch"]),

    async onClick(evtClick, doneFn) {
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        const err = new Error(this.$t("invalid_form_fields"));
        this.$store.dispatch("notify/error", err);
        return;
      }

      const formData = new FormData();

      formData.append('file', this.file);

      formData.append('activeData', JSON.stringify(this.active));

      await this.addSimcardsBatch(formData);

      this.addSimcardsBatchErrors.length
        ? $('#modalErrors').modal('show')
        : this.$store.dispatch('toast/showToast', {
            message: 'Simcard(s) cadastrado(s) com sucesso!',
            type: 'success',
          });

      this.active = {
        model: undefined,
        purchaseDate: "",
        purchaseValue: 0,
        warrantyDate: "",
        activeType: 6,
        location: '',
        status: undefined
      }

      this.file = null
    }
  },

  async mounted() {
    const { dispatch } = this.$store;

    try {
      dispatch("overlay/show", true);

      await Promise.all([
        dispatch("activestype/fetchAll"),
        dispatch("model/fetchFiltered", {
          activeType: 6,
          activeForm: true,
        }),
      ]);

      const { location, status } = this.activestypes.find(activeType => activeType.id === 6)

      if (location) {
        this.active.location = location
      }

      if (status) {
        this.active.status = status
      }

    } catch (error) {
      console.log('[ERROR-FETCH-ALL-MOUNTED] => ', error)
    } finally {
      dispatch("overlay/show", false);
    }
  },
};
</script>
